export class QueryDetailsModel {
    "queryId": Number;
    "userId": Number;
}